/* eslint-disable camelcase, import/prefer-default-export */
import { AxiosResponse } from 'axios';

export const API = 'permission/role/modify';

type p5_role_id = string //  角色GUID
type p3_bre_status = '3' | '-2' //  狀態:3.啟用 -2.停用
type p3_bre_sort = number //  排序
type p3_bre_name = string //  名稱
type p3_bre_specific = string //  類型:請忽略此項目
type p3_bre_p3_bch_id = number //  所屬站台ID
type p3_bre_memo = string // 備註

export interface request {
  p5_role_id?: p5_role_id,
}

export interface AxiosResponse extends AxiosResponse<responseExtends> { }

interface responseExtends extends backendResponse {
  response: response
}

export type response = {
  role: any
  node: any
  role_node: any
  p5_role_id: p5_role_id,
  p3_bre_status: p3_bre_status,
  p3_bre_sort: p3_bre_sort,
  p3_bre_name: p3_bre_name,
  p3_bre_specific?: p3_bre_specific,
  p3_bre_p3_bch_id: p3_bre_p3_bch_id,
  p3_bre_memo?: p3_bre_memo,
}

export type node = {
  crud: number
  p3_bne_id: number
  p3_bne_name: string
  p3_bne_p3_bch_id: number
  p3_bne_p4_node_id: number
  p4_node: string
}
